interface NombrePersonal {
    primerNombre: string;
    nombresSecundarios: string;
    apellidoPaterno: string;
    apellidoMaterno: string;
}

export function nombreCompletoConNombresPrimero(nombre: NombrePersonal) {
    let nombreCompleto = nombre.primerNombre;
    if (nombre.nombresSecundarios) nombreCompleto += ' ' + nombre.nombresSecundarios;
    if (nombre.apellidoPaterno) nombreCompleto += ' ' + nombre.apellidoPaterno;
    if (nombre.apellidoMaterno) nombreCompleto += ' ' + nombre.apellidoMaterno;
    return nombreCompleto;
}

export function nombreCompletoConApellidosPrimero(nombre: NombrePersonal) {
    let nombreCompleto = nombre.apellidoPaterno;
    if (nombre.apellidoMaterno) nombreCompleto += ' ' + nombre.apellidoMaterno;
    if (nombre.primerNombre) nombreCompleto += ' ' + nombre.primerNombre;
    if (nombre.nombresSecundarios) nombreCompleto += ' ' + nombre.nombresSecundarios;
    return nombreCompleto;
}

export function compararNombresConApellidosPrimero(
    nombreA: NombrePersonal,
    nombreB: NombrePersonal,
) {
    return (
        nombreA.apellidoPaterno.localeCompare(nombreB.apellidoPaterno, 'es') ||
        nombreA.apellidoMaterno.localeCompare(nombreB.apellidoMaterno, 'es') ||
        nombreA.primerNombre.localeCompare(nombreB.primerNombre, 'es') ||
        nombreA.nombresSecundarios.localeCompare(nombreB.nombresSecundarios, 'es')
    );
}

export function compararNombresConNombresPrimero(nombreA: NombrePersonal, nombreB: NombrePersonal) {
    return (
        nombreA.primerNombre.localeCompare(nombreB.primerNombre, 'es') ||
        nombreA.nombresSecundarios.localeCompare(nombreB.nombresSecundarios, 'es') ||
        nombreA.apellidoPaterno.localeCompare(nombreB.apellidoPaterno, 'es') ||
        nombreA.apellidoMaterno.localeCompare(nombreB.apellidoMaterno, 'es')
    );
}



// WEBPACK FOOTER //
// ./src/utilidades/nombrePersonal.ts